import { Modal } from "./Modal";
import { Button, ProgressBar, SectionHeader, StatTile, Tag, Icon as DsIcon } from "./ds";
import "./reliability.css";

// v35 — popup k dlaždici „Spoľahlivosť". Číslo počíta server (reliability.py) a posiela ho
// aj s rozpisom zložiek — tu sa nič neprepočítava, len vysvetľuje. Zložky, váhy aj texty
// prídu z backendu, takže sa vzorec a jeho vysvetlenie nikdy nerozídu.
export function ReliabilityModal({ rel, onWeek, onClose }) {
  if (!rel) return null;
  const parts = rel.parts || [];
  const gold = rel.gold_weeks || 0;
  const silver = rel.silver_weeks || 0;
  const dni = (n) => (n === 1 ? "deň" : n >= 2 && n <= 4 ? "dni" : "dní");
  const tyzdnov = (n) => (n === 1 ? "týždeň" : n >= 2 && n <= 4 ? "týždne" : "týždňov");
  return (
    <Modal center title="Spoľahlivosť" icon="shield" maxWidth={420} onClose={onClose}>
      <div className="bz-rel__head">
        <span className="bz-rel__score">{rel.score} %</span>
        <div className="bz-rel__headmeta">
          <ProgressBar pct={rel.score} />
          <div className="bz-rel__hint">
            {rel.days > 0
              ? `z posledných ${rel.days} hodnotených ${dni(rel.days)}`
              : "zatiaľ bez histórie — index začína na neutrálnych 50 %"}
            {rel.provisional && rel.days > 0 ? " · predbežné" : ""}
          </div>
        </div>
      </div>
      {rel.provisional && (
        <Tag tone="info" size="xs" icon="clock">Predbežné — ustáli sa históriou</Tag>
      )}
      <div className="bz-rel__lede">
        Jedno číslo o tom, ako sa dá na teba spoľahnúť. Skladá sa z piatich vecí — každá má svoju
        váhu a každá sa počíta len z dní, ktoré sa naozaj dali splniť.
      </div>
      {parts.map((p) => (
        <div className="bz-rel__part" key={p.key}>
          <div className="bz-rel__partrow">
            <span className="bz-rel__partlabel">{p.label}</span>
            <span className="bz-rel__partweight">váha {p.weight} %</span>
            <span className="bz-rel__partval">{p.pct} %</span>
          </div>
          <ProgressBar pct={p.pct} size="sm" />
          {p.detail && <div className="bz-rel__partdetail">{p.detail}</div>}
          <div className="bz-rel__partdesc">{p.desc}</div>
        </div>
      ))}
      <SectionHeader label="Týždenná konzistencia" style={{ marginTop: 18 }} />
      <div className="bz-statgrid2" style={{ marginTop: 12 }}>
        <StatTile accent="var(--stat-sun)" icon={<DsIcon name="medal" size={24} color="currentColor" />}
          value={gold} label="Zlaté týždne" sub={gold >= 52 ? "Zlatý rok je tvoj 👑" : `ešte ${52 - gold} ${tyzdnov(52 - gold)} do Zlatého roka`} />
        <StatTile accent="var(--stat-growth)" icon={<DsIcon name="medal2" size={24} color="currentColor" />}
          value={silver} label="Strieborné týždne" sub="týždeň so 6 splnenými dňami zo 7" />
      </div>
      {/* Vstup do popupu „Ako prebiehal týždeň" priamo pod počítadlami medailí: rekapitulácia
          JE detail tohto čísla (z čoho posledná medaila vznikla), takže Prehľad nepotrebuje
          ďalšiu dlaždicu — stačí sa napojiť na to, čo tu už je. */}
      {onWeek && (
        <Button variant="ghost" size="sm" block onClick={onWeek} style={{ marginTop: 10 }}>
          <DsIcon name="calendar" size={15} color="currentColor" />
          Ako prebiehal minulý týždeň
          <DsIcon name="chevron" size={14} color="currentColor" />
        </Button>
      )}
      <div className="bz-rel__note">
        Zlatý týždeň = všetkých 7 dní splnených, strieborný = 6 zo 7. Deň, keď si nemal/a nič
        naplánované, sa počíta ako splnený — presne ako pri sérii.
        {rel.provisional
          ? " Kým nemáš aspoň 28 hodnotených dní, index sa mieša s neutrálnymi 50 % — aby nikto"
            + " nemal 99 % po troch dňoch a nepredbehol tak človeka s dlhou históriou."
          : ""}
      </div>
    </Modal>
  );
}
